import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

// Thunk to fetch FAQ data
export const fetchFAQData = createAsyncThunk("faq/fetchFAQData", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/faq/");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

const faqSlice = createSlice({
  name: "faq",
  initialState: {
    faqData: [],
    faqLoading: false,
    faqError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFAQData.pending, (state) => {
        state.faqLoading = true;
        state.faqError = null;
      })
      .addCase(fetchFAQData.fulfilled, (state, action) => {
        state.faqLoading = false;
        state.faqData = action.payload;
      })
      .addCase(fetchFAQData.rejected, (state, action) => {
        state.faqLoading = false;
        state.faqError = action.payload;
      });
  },
});

export default faqSlice.reducer;
